'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../../../i-bem/i-bem.react');

var _bUserAccountEAccentLetter = (require('./../../__accent-letter/user-account__accent-letter.react.js').default || require('./../../__accent-letter/user-account__accent-letter.react.js')).applyDecls();

var _bUserAccountEAccentLetter2 = _interopRequireDefault(_bUserAccountEAccentLetter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.declMod)({ hasAccentLetter: true }, {
    block: 'user-account',
    elem: 'name',
    content: function content(_ref) {
        var text = _ref.text,
            children = _ref.children;

        if (text && !children) {
            var name = String(text);

            return [_react2.default.createElement(
                _bUserAccountEAccentLetter2.default,
                { key: 'accent-letter' },
                name.charAt(0)
            ), name.slice(1)];
        }

        return children;
    }
}, {
    propTypes: {
        text: _propTypes2.default.string
    }
});